import { Outlet } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// section
import Footer from './Footer';

export default function CommerceLayout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: 1, }}> 
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mb: 20,
        }}
      >
        <Outlet />
      </Box>        
      <Footer />
    </Box>
  );
}